import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

// Icons
import CheckIcon from "@material-ui/icons/Check";

// Backgrounds
import phones from "../assets/backgrounds/contact_img.png";

// Components
import Section from "../components/Section/Section";
import SectionTitle from "../components/SectionTitle/SectionTitle";
import styles from "../config/styles";
import FormContainer from "../components/FormContainer/index";
import HighlightColor from "../components/HighlightColor/index";
import DemoVideoForm, { sources } from "../components/DemoVideoForm/index";

const useStyles = makeStyles(theme => ({
  bigIcon: {
    marginTop: theme.spacing(6)
  },
  formSection: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.paper
  },
  sectionBottom: {
    padding: theme.spacing(4)
  },
  form: {
    ...styles.mixins.form,
    backgroundColor: theme.palette.background.default,
    boxShadow: "10px 20px 60px #00000010",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
      boxShadow: "none",
      background: "transparent",
      padding: 0
    }
  },
  formData: {
    padding: "100px 0 40px",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0
    }
  },
  phones: {
    ...styles.mixins.icon,
    display: "flex",
    width: "50%",
    margin: `${theme.spacing(2)}px 0px`,
    marginRight: theme.spacing(4),
    backgroundImage: `url(${phones})`,
    backgroundPosition: "center center",
    [theme.breakpoints.down("sm")]: {
      maxWidth: 430,
      width: "100%",
      height: 430,
      margin: "0 auto"
    }
  },
  highlight: {
    fontWeight: 800
  }
}));

const RequestReportPage = () => {
  const classes = useStyles();
  const [isSent, setSent] = useState(false);

  const handleFormSubmit = () => {
    setSent(true);
  };

  return (
    <Section isMain>
      <SectionTitle
        title={
          <>
            Request reports and{" "}
            <HighlightColor className={classes.highlight}>
              BLUEPRINT
            </HighlightColor>
          </>
        }
        description="You’ll be glad you did."
      />
      <FormContainer className={classes.form}>
        <div className={classes.phones} />
        <DemoVideoForm
          className={classes.formData}
          hideUserType
          source={sources.BLUEPRINT}
          onSuccess={handleFormSubmit}
          buttonText={
            isSent ? (
              <>
                Sent
                <CheckIcon />
              </>
            ) : (
              "Send"
            )
          }
        />
      </FormContainer>
    </Section>
  );
};

export default RequestReportPage;
